import { Button, Form, Input } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { CreateWashingMachinePartRequest } from '@/types/apis/washingMachinePart/CreateWashingMachinePartRequest'

import { SpaceCustom } from '../../style'

type Props = {
  onSubmit: (formValues: CreateWashingMachinePartRequest) => void
}

const CreateWashingMachinePartForm = ({ onSubmit }: Props) => {
  const { t } = useTranslation()

  const [form] = Form.useForm<CreateWashingMachinePartRequest>()

  const handleSubmit = (values: CreateWashingMachinePartRequest) => {
    onSubmit(values)
  }

  return (
    <Form layout="vertical" onFinish={handleSubmit} form={form}>
      <Form.Item
        label={t('components.pages.washingMachinePart.create.form.name')}
        name="name"
        rules={[{ required: true, message: t('components.pages.washingMachinePart.create.form.requireName') }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={t('components.pages.washingMachinePart.create.form.manufacturer')}
        name="manufacturer"
        rules={[{ required: true, message: t('components.pages.washingMachinePart.create.form.requireManufacture') }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={t('components.pages.washingMachinePart.create.form.supplier')}
        name="supplier"
        rules={[{ required: true, message: t('components.pages.washingMachinePart.create.form.requireSupplier') }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={t('components.pages.washingMachinePart.create.form.price')}
        name="price"
        rules={[{ required: true, message: t('components.pages.washingMachinePart.create.form.requirePrice') }]}
      >
        <Input type="number" min={0} />
      </Form.Item>

      <Form.Item
        label={t('components.pages.washingMachinePart.create.form.inventory')}
        name="inventory"
        rules={[{ required: true, message: t('components.pages.washingMachinePart.create.form.requireInventory') }]}
      >
        <Input type="number" min={0} />
      </Form.Item>

      <SpaceCustom>
        <Button type="primary" htmlType="submit">
          {t('components.pages.washingMachinePart.create.form.addNew')}
        </Button>
      </SpaceCustom>
    </Form>
  )
}

CreateWashingMachinePartForm.displayName = 'CreateWashingMachinePartForm'
export default CreateWashingMachinePartForm
